import DynamicText from "./DynamicText";
import { ReactNode } from "react";
import { TextContainer, Paragraph } from "frno-react";
import TextWithUrl from "./TextWithUrl";

type SegmentProps = {
  headerKey: string;
  headerVariable?: string | number;
  mainContent: string | ReactNode;
};
export default function Segment({
  headerKey,
  headerVariable,
  mainContent,
}: SegmentProps) {
  const boldHeaders = new Set([
    "page.savingsprofiles.table.expandedrow.profileinfo.referenceindex",
    "page.savingsprofiles.table.expandedrow.riskinformation.header",
    "page.companies.table.expandedrow.feedescription.header",
    "page.companies.table.expandedrow.setupfeedescription.header",
    "page.companies.table.expandedrow.productdetails.header",
  ]);
  const isBold = boldHeaders.has(headerKey);

  return (
    <TextContainer>
      <h4 className={`fs-body mt-8`}>
        <DynamicText
          className={isBold ? "bold-header" : ""}
          textKey={headerKey}
          replaceComponent={headerVariable}
        />
      </h4>
      <Paragraph className="mt-2">
        <TextWithUrl mainContent={mainContent} />
      </Paragraph>
    </TextContainer>
  );
}
